module.exports = __webpack_public_path__ + "static/img/ag_10.429c804.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント/ag_10.png
// module id = 868
// module chunks = 1